import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [colors, setColors] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listColor() {
    let response = await wsGetAll('sale/bono-colores');
    if (response.success) setColors(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        color_id: null,
        type: '',
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            type : (item.TIPO.toString()).toUpperCase(),
            color_id : item.COLORID,
            min_bonus: item.MINBONUS,
            max_bonus: item.MAXBONUS,
            min_apply: item.MINAPPLY,
            max_apply: item.MAXAPPLY,
          };
        }),
        // SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.color_id) {
      setDataChanging((prev) => ({
        ...prev,
        color_id: bPartnerSelect?.color_id || null,
        type: bPartnerSelect?.type || '',
      }));
    }
  }, [bPartnerSelect]);

  
  useEffect(() => {
      if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listColor();
      setDataChanging(customerPortfolioB);
      }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo bono de ventas`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.color_id
            ? 'sale/bono-venta'
            : 'sale/bono-venta/multiple'
        }
        dataForce={
          dataChanging.color_id
            ? {
                color_id: dataChanging.color_id,
                type: dataChanging.type,
              }
            : {
                color_id: cuota.valueSearch?.color_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Autocomplete
                disableClearable
                options={colors}
                getOptionLabel={(item) => `${item.description}`}
                renderInput={(params) => (
                    <TextField {...params} label="Colores" margin="normal" fullWidth />
                )}
                onChange={(e, item) => {handleChange('color_id', item?.id); setDataImport(null);}}
                value={colors.find((color) => color.id === dataChanging.color_id) || null}
                style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <ImportExcel
                setDataImport={setDataImport}
                btnColor="success"
                validDuplicate="TIPO"
                sortDuplicate="TIPO"
                downTemplate={{
                    fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de bonos para ventas`,
                    fields: ['TIPO','COLORID','MINBONUS','MAXBONUS','MINAPPLY','MAXAPPLY']
                }}
            />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.color_id ? (
          <>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                value={dataChanging.type || ''}
                inputProps={{
                  name: 'type',
                  onChange: (e) => handleChange('type', e.target.value),  
                }}
              >
                <MenuItem value="SU">Supervisor</MenuItem>
                <MenuItem value="VE">Vendedor</MenuItem>
              </Select>
            </FormControl>
          </>
        ) : undefined}
        {dataChanging.type ? (
          <>
            <TextField
              label="Bonus Minimo"
              fullWidth
              type="number"
              name="min_bonus"
              margin="normal"
              value={dataChanging.min_bonus || ''}
              onChange={(e) => handleChange('min_bonus', e.target.value)}
              required
            />
            <TextField
              label="Bonus Maximo"
              fullWidth
              type="number"
              name="max_bonus"
              margin="normal"
              value={dataChanging.max_bonus || ''}
              onChange={(e) => handleChange('max_bonus', e.target.value)}
              required
            />
            <TextField
              label="Apply minimo"
              fullWidth
              type="number"
              name="min_apply"
              margin="normal"
              value={dataChanging.min_apply || ''}
              onChange={(e) => handleChange('min_apply', e.target.value)}
              required
            />
            <TextField
              label="Apply maximo"
              fullWidth
              type="number"
              name="max_apply"
              margin="normal"
              value={dataChanging.max_apply || ''}
              onChange={(e) => handleChange('max_apply', e.target.value)}
              required
            />
          </>
        ): undefined}
      </Modal>
    </>
  );
});
